export default "__VITE_ASSET__DxZXXfKa__"